import React from 'react';
import PropTypes from 'proptypes';

const ItineraryModal = ({ closeModal, mailingCountry }) => (
  <div>
    <div className="row">
      <button className="square-icon right" onClick={closeModal}>
        X
      </button>
    </div>
    <h3>BOOKING YOUR FLIGHTS</h3>
    <p>
      You are responsible for booking your own flights to and from your trip location. Our dedicated
      flight agents help book your flights with ease with routing and logistics, arriving during
      GIVE’s arrival times, provide 24/7 support, and when possible, coordinating flights with other
      travelers.
    </p>
    <p>
      GIVE will email you once flights are released for your trip (you can also see this from your
      GIVE Profile).{' '}
      <b>
        Once flights are released, submit your flight booking request form below as soon as possible
      </b>
      . Our agents will email itinerary quotes and help you book round-trip flights from your home
      city to your host location. Make sure to book your flights early!
    </p>
    <p>
      <b>Important:</b>Keep an eye on your email as quoted airfare is valid for a limited time.
      Flight prices change daily based on availability and there are no guarantees on available
      ticket prices. To get the best fares, book as soon as flights are released.
    </p>

    <h4>HOW TO BOOK</h4>
    <p>
      <b>1. </b> Submit a booking{' '}
      <a href="https://go.givevolunteers.org/bookflights" target="_blank" rel="noopener noreferrer">
        booking request form
      </a>
      !
    </p>
    <p>
      <b>2. </b>
      After purchasing your flights, enter your arrival/departure dates and flight numbers in your
      GIVE Profile under the Flight Itinerary section of your Trip Checklist.
    </p>

    <ul>
      <li>
        Have questions about your airfare quotes or flights? Respond to your flight agent for
        suppport. If you have general questions about flights or the process, Email:{' '}
        <a href="mailto:info@givevolunteers.org">info@givevolunteers.org</a> (only email general
        questions – for flight quotes, submit a booking form)
      </li>
    </ul>

    <h4>WHY SHOULD I BOOK WITH GIVE'S DEDICATED AGENTS?</h4>
    <ul>
      <li>Access to exclusive available airfare rates</li>
      <li>Help coordinating flights with other travelers traveling along the same route</li>
      <li>Confidence that layovers are realistic so you don’t miss your connecting flight(s)</li>
      <li>
        24/7 support flight assistance while traveling (not available when booking on your own.){' '}
      </li>
      <li>
        {' '}
        Our agents can also price match, if you find a better price on the exact same itinerary.
      </li>
    </ul>
    <h4>SPECIAL BOOKING CIRCUMSTANCES</h4>
    <p>
      GIVE volunteers have a spark for adventure, so we understand if you’d like to arrive early or
      extend your flights to continue traveling. We also know that some volunteers prefer to book
      with miles. If you’d like to book your flights outside of our booking agents, then we require
      you to email us your preferred itinerary <b>prior to booking</b>. Note that if you arrive or
      depart outside of our suggested itinerary times, you will be responsible for your own airport
      transportation and any additional accommodation fees outside of your GIVE trip dates.
    </p>
  </div>
);

ItineraryModal.propTypes = {
  mailingCountry: PropTypes.string.isRequired,
  closeModal: PropTypes.func.isRequired,
};

export default ItineraryModal;
